import { request, requestList, buildQuery, orgBase } from '@/api/http'
import type {
  Inventory,
  CreateInventoryRequest,
  UpdateInventoryRequest,
  ImportResult,
  ImportFrom,
  Economics,
} from '@/api/types'

export const inventoriesApi = {
  list(orgId: string, params?: { limit?: number; offset?: number }): Promise<Inventory[]> {
    return requestList(`${orgBase(orgId)}/inventories${buildQuery(params)}`)
  },
  get(orgId: string, invId: string): Promise<Inventory> {
    return request(`${orgBase(orgId)}/inventories/${invId}`)
  },
  create(orgId: string, body: CreateInventoryRequest): Promise<Inventory> {
    return request(`${orgBase(orgId)}/inventories`, { method: 'POST', body: JSON.stringify(body) })
  },
  update(orgId: string, invId: string, body: UpdateInventoryRequest): Promise<Inventory> {
    return request(`${orgBase(orgId)}/inventories/${invId}`, {
      method: 'PUT',
      body: JSON.stringify(body),
    })
  },
  remove(orgId: string, invId: string): Promise<void> {
    return request(`${orgBase(orgId)}/inventories/${invId}`, { method: 'DELETE' })
  },
  import(orgId: string, invId: string, from: ImportFrom): Promise<ImportResult> {
    return request(`${orgBase(orgId)}/inventories/${invId}/import${buildQuery({ from })}`, {
      method: 'POST',
    })
  },
  // ── Economics (inventory-level) ──────────────────────────────────────────
  getEconomics(orgId: string, invId: string): Promise<Economics> {
    return request(`${orgBase(orgId)}/inventories/${invId}/economics`)
  },
  setEconomics(orgId: string, invId: string, body: Economics): Promise<Economics> {
    return request(`${orgBase(orgId)}/inventories/${invId}/economics`, {
      method: 'PUT',
      body: JSON.stringify(body),
    })
  },
  setSourceEconomics(orgId: string, sourceId: string, body: Partial<Economics>): Promise<Economics> {
    return request(`${orgBase(orgId)}/sources/${sourceId}/economics`, {
      method: 'PUT',
      body: JSON.stringify(body),
    })
  },
}
